import { Fragment, type FC } from "react";

import {
  Box,
  Column,
  Menu,
  MenuActionsButton,
  MenuItem,
  MenuList,
  Text,
} from "@hightouch/htui";
import type { ComponentType, SVGAttributes } from "react";

import { DescriptionAddIcon } from "@hightouch/htui";
import { ConditionType } from "src/types/visual";

export type FilterActionsMenuItem = {
  label: string;
  description: string;
  isDisabled?: boolean;
  onClick?: () => void;
  icon: ComponentType<SVGAttributes<SVGElement>>;
};
type FilterActionsMenuProps = {
  items: FilterActionsMenuItem[];
};

export const FilterActionsMenu: FC<Readonly<FilterActionsMenuProps>> = ({
  items,
}) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <Menu>
      <MenuActionsButton />
      <MenuList>
        {items.map((item) => (
          <Fragment key={item.label}>
            {item.onClick && (
              <Box
                as={MenuItem}
                color="text.secondary"
                icon={item.icon}
                isDisabled={item.isDisabled}
                sx={{
                  svg: {
                    height: "24px",
                    width: "24px",
                  },
                }}
                onClick={item.onClick}
              >
                <Column>
                  <Text fontWeight="medium">{item.label}</Text>
                  <Text color="text.secondary">{item.description}</Text>
                </Column>
              </Box>
            )}
          </Fragment>
        ))}
      </MenuList>
    </Menu>
  );
};

/**
 * Builds the "Add … group" menu entry for nesting the opposite of the current AND/OR context.
 */
export function makeAddNestedGroupMenuItem({
  currentConditionType,
  onGroup,
  isDisabled,
}: {
  currentConditionType: ConditionType.And | ConditionType.Or;
  onGroup: () => void;
  isDisabled?: boolean;
}): FilterActionsMenuItem {
  const quoted = currentConditionType === ConditionType.And ? '"OR"' : '"AND"';
  return {
    label: `Add ${quoted} group`,
    description: `Create a nested ${quoted} group from this filter`,
    icon: DescriptionAddIcon,
    onClick: onGroup,
    isDisabled,
  };
}
